<mat-form-field appearance="outline" class="full-width">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required">
    <mat-select-trigger>
      @if (selectedCar) {
        <span class="car-trigger">
          <span class="car-trigger-main">
            <span class="car-title">{{ selectedCar.car_title }}</span>
            @if (selectedCar.license_plate) {
              <span class="car-plate">· {{ selectedCar.license_plate }}</span>
            }
          </span>
          <span class="car-status-chip">
            <span class="status-chip status-{{ selectedCar.status }}">{{ selectedCar.status | statusLabel:'availability' }}</span>
          </span>
        </span>
      }
    </mat-select-trigger>

    <mat-option *ngFor="let c of cars" [value]="c.car_id">
      <span class="car-text">
        <span class="car-title">{{ c.car_title }}</span>
        <span class="car-plate" *ngIf="c.license_plate">{{ c.license_plate }}</span>
      </span>
      <span class="car-status-chip">
        <span class="status-chip status-{{ c.status }}">{{ c.status | statusLabel:'availability' }}</span>
      </span>
    </mat-option>
  </mat-select>
  <mat-error *ngIf="showServerError()">{{ serverError() }}</mat-error>
</mat-form-field>
